import { createFileRoute } from '@tanstack/react-router';

import { getInventoryQueryOptions } from '@/_pages/inventories/api-service';
import Loading from '@/_pages/inventories/vendors/loading';

export const Route = createFileRoute('/_private/inventory/_template/$id/vendors')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getInventoryQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Vendors',
    tabKey: 'inventory/vendors',
  },
  pendingComponent: Loading,
});
